import { ChangeDetectionStrategy, Component } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { AppRoutes } from '../../../../shared/constants/enums'
import { RepresentativeDto } from '../../../../shared/models/auth.interfaces'
import { AuthService } from '../../../services/auth.service'
import { DashboardSidebarService } from '../../../services/dashboard-sidebar.service'

@Component({
    selector: 'app-dashboard-layout-topbar',
    templateUrl: './dashboard-layout-topbar.component.html',
    styleUrls: ['./dashboard-layout-topbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardLayoutTopbarComponent {
    constructor(
        private dashboardSidebarService: DashboardSidebarService,
        private authService: AuthService,
        private router: Router
    ) {}

    protected logout(): void {
        this.router.navigate(['/', AppRoutes.LOGGED_OUT])
    }

    get currentRepresentative$(): Observable<RepresentativeDto | null> {
        return this.authService.currentRepresentative
    }

    get isOpenSidebar$(): Observable<boolean> {
        return this.dashboardSidebarService.isOpenSidebar$
    }
}
